var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1441.76 275.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6a729;\n      }\n\n      .cls-2 {\n        fill: url(#Nowa_pr\xF3bka_gradientu_1);\n      }\n\n      .cls-3 {\n        fill: #e6511e;\n        opacity: .59;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nowa_pr\\xF3bka_gradientu_1",
    "data-name": "Nowa pr\\xF3bka gradientu 1",
    x1: 0,
    y1: 261.31,
    x2: 1441,
    y2: 261.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00a0af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00964f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00964f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00964f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#34a74b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#69ba48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#96c945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#bcd643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d8e041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ede740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f9eb3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#feed3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#feed3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f6a729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f6a729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ed714f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ee8b9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ee8b9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e6849c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d27397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#b1568f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#832e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#701e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#701e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#272882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#272882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#243088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1759a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0d78c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#058fd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#019ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00a2e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00a2e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00a0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#009fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009eb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#009eb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#009eaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#009eaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00964f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#24a24c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#51b14a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#7bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9fcb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#bcd543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#d5dd42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e7e441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f5e840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fceb40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ffec40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ffec40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffec40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f29345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f29345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ec744c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ec744c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ec7865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ed7d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ed8196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ed84a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ed86ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ee87b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ea83af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#df7aab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cc6ba3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b15599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#903a8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6f1f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6f1f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#005ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#005ca3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#008dcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#00a4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#009cab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009cab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blenda"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,247.98l.43-23.19s25.67-18.99,59.35-21.14c48.2-3.08,65.58-5.97,77.4-15.05,23.73-18.23-.56-75.63,45.5-116.09C235.71,25.93,300.87,14.49,385.12,3.47c156.23-20.42,301.03,55.95,438.84,54.09,137.82-1.85,333.7-31.53,430.43-22.92,120.75,10.75,187.37,67,187.37,67V247.98H0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 246.86,
    width: 1441,
    height: 28.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1035.96,140.25c61.49,24.72,169.28,16.84,184.3-11.66,18.41-34.95-7.73-99.95-58.7-116.33-66.22-21.28-118.73-4.13-139.79,12.44-52.27,41.13-38.7,94.28,14.18,115.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1035.96,140.25c61.49,24.72,169.28,16.84,184.3-11.66,18.41-34.95-7.73-99.95-58.7-116.33-66.22-21.28-118.73-4.13-139.79,12.44-52.27,41.13-38.7,94.28,14.18,115.54Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.316c86674f8f1a75ac0bd5d4889f1761.svg";
export { ForwardRef as ReactComponent };